import React from 'react';
import './TechStack.css';

const TechStack = () => {
  const technologies = [
    // Languages
    'JavaScript', 'Kotlin', 'TypeScript', 'Scala', 'C/C++', 'SQL', 'Golang', 'Python', 'HTML/CSS/SASS', 'VHDL', 'Java',
    // Frameworks & Libraries
    'React Native', 'React', 'Tailwind', 'Flask', 'FastAPI', 'Pandas', 'NumPy', 'Matplotlib',
    // Tools & Platforms
    'AWS', 'GCP', 'Azure', 'Raspberry Pi', 'Arduino', 'Snowflake'
  ];

  return (
    <div className="tech-stack">
      <div className="scroll-container">
        <div className="scroll-content">
          {technologies.map((tech, index) => (
            <div key={`first-${index}`} className="tech-item">
              {tech}
            </div>
          ))}
          {technologies.map((tech, index) => (
            <div key={`second-${index}`} className="tech-item">
              {tech}
            </div>
          ))}
        </div>
      </div>
      <div className="tech-stack-line" />
    </div>
  );
};

export default TechStack; 